export enum PressureUnitEnum {
  MM_HG = 'MM_HG',
  CM_H2O = 'CM_H2O',
}
